import React from 'react';
import './App.css';
import FormUser from './components/FormUser'

function App() {
  return (
    <div className="App">
      <FormUser />
    </div>
  );
}

export default App;
